module.exports = __webpack_public_path__ + "img/logo-popmerch.2a5730fd.png";